/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandLinkRel, CommandResource } from '@alfa-client/command-shared';
import { StateResource } from '@common/tech-shared';
import { UserProfileComponent, UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-user-profile-in-historie-container',
  templateUrl: './user-profile-in-historie-container.component.html',
  styleUrls: ['./user-profile-in-historie-container.component.scss'],
  imports: [CommonModule, UserProfileComponent],
})
export class UserProfileInHistorieContainerComponent implements OnInit {
  private readonly userProfileService = inject(UserProfileService);

  readonly command = input.required<CommandResource>();

  userProfileStateResource$: Observable<StateResource<UserProfileResource>>;

  ngOnInit(): void {
    this.userProfileStateResource$ = this.userProfileService.getAssignedUserProfile(this.command(), CommandLinkRel.CREATED_BY);
  }
}
